import { themeColors, rgbColor } from "helpers/utils";

Number.prototype.formatDecimalPlaces = function () {
    let decimals = arguments[0];
    if (!decimals || isNaN(decimals))
        decimals = 0;

    return this.toLocaleString('en-UK', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

const colours = [rgbColor(themeColors.info), rgbColor(themeColors.success), rgbColor(themeColors.warning)];

export const coqCols = [
    {
        accessor: 'OriginalJobno',
        Header: 'Original Job No.',
        isVisible: true
    },
    {
        accessor: 'ReplacementJobno',
        Header: 'Replacement Job No.',
        isVisible: true,
        type: 'ccf-odr-link',
    },
    {
        accessor: 'OriginalGlassID',
        Header: 'Glass ID',
        isVisible: true
    },
    {
        accessor: 'OriginalCost',
        Header: 'Original Cost',
        isVisible: true
    },
    {
        accessor: 'RecordedDate',
        Header: 'Recorded Date',
        isVisible: true
    },
    {
        accessor: 'ReplacementDeliveryDate',
        Header: 'Replacement Del. Date',
        isVisible: true
    },
];

export const coqOptions = {
    title: {
        show: false,
    },
    tooltip: {
        trigger: 'axis',
        show: true,
        axisPointer: {
            type: 'cross'
        },
        formatter: function (params) {
            const buildHtml = (html, data) => html +=
                data.map(x => `<p>${x?.seriesName ?? ""}&nbsp${x?.marker}&nbsp${((x?.seriesName == 'Cost' ? '£' : '') +
                    x?.value?.formatDecimalPlaces(x.seriesName == 'Qty' ? 0 : 2)) ?? ""}</p>`).join('');

            return buildHtml(`<h3>${params[0].axisValueLabel}</h3>`,
                [params.filter(x => x.seriesName == 'Qty')[0], params.filter(x => x.seriesName == 'Cost')[0],
                params.filter(x => x.seriesName == 'Qty %')[0], params.filter(x => x.seriesName == 'Threshold')[0]]
                    .filter(x => x != null));
        }
    },
    legend: {
        data: ['Cost', 'Qty', 'Qty %']
    },
    xAxis: {
        type: 'category',
        data: ['30 Day', '60 Day', '120 Day', '12 Month', '12+ Month']
    },
    yAxis: [
        {
            type: 'value',
            name: 'Qty %',
            position: 'left',
            alignTicks: true,
            axisLine: {
                show: true,
            },
        },
        {
            type: 'value',
            name: 'Cost',
            position: 'right',
            alignTicks: true,
            axisLine: {
                show: true,
            },
            axisLabel: {
                formatter: '£{value}'
            }
        },
        {
            type: 'value',
            name: 'Qty %',
            position: 'right',
            offset: 80,
            alignTicks: true,
            axisLine: {
                show: true,
            },
            axisLabel: {
                formatter: '{value}%'
            }
        },
    ],
    series: [
        {
            data: [1200, 600, 300, 600, 1200],
            type: 'line',
            smooth: true,
            name: 'Qty',
            itemStyle: {
                color: colours[0],
            },
            z: 2
        },
        {
            data: [600, 300, 150, 300, 600],
            type: 'bar',
            itemStyle: {
                color: colours[1],
                borderRadius: [5, 5, 0, 0],
            },
            name: 'Cost',
            yAxisIndex: 1,
            z: 2
        },
        {
            data: [1, .5, .5, .5, 1],
            type: 'line',
            itemStyle: {
                color: colours[2],
            },
            name: 'Qty %',
            yAxisIndex: 2,
            symbol: 'roundRect',
            symbolSize: 6,
            lineStyle: {
                opacity: 0.5
            },
            z: 2
        },
    ],
};

export const costGaugeOptions = {
    series: [
        {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            center: ['50%', '40%'],
            pointer: {
                show: false
            },
            progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
            },
            axisLine: {
                lineStyle: {
                    width: 20
                }
            },
            splitLine: {
                show: false,
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false,
            },
            min: 0,
            max: 100,
            title: {
                fontSize: 14
            },
            detail: {
                width: 90,
                height: 12,
                fontSize: 12,
                color: 'inherit',
                borderColor: 'inherit',
                borderRadius: 20,
                borderWidth: 1,
                formatter: value => `£${value.toFixed(2)}`,
            }
        }
    ]
}

export const yearStackOptions = {
    title: {
        show: false,
    },
    tooltip: {
        trigger: 'axis',
        show: true,
        axisPointer: {
            type: 'cross',
            snap: true
        },
        formatter: function (params) {
            return `<h3>${params[0].name}</h3><p>
                <ul style="list-style-type:none;">
                    ${params.map(x => `<li>${x.marker} ${x.seriesName}: ${x.value}</li>`).join('')}
                </ul>
            </p>`;
        }
    },
    legend: {
        show: true,
    },
    yAxis: {
        type: 'value',
    },
    series: [
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'Remakes',
            silent: true,
        },
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'Thirty Days',
            silent: true,
        },
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'Sixty Days',
            silent: true,
        },
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'One Twenty Days',
            silent: true,
        },
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'One Year',
            silent: true,
        },
        {
            data: [],
            type: 'bar',
            stack: 'total',
            name: 'One Year Plus',
            silent: true,
        },
    ],
}
